import type Owner from '@ember/owner';
import { service } from '@ember/service';

import type { PopupData, Service } from 'webapp-types';
import type { BillingFeature } from 'webapp/enums/enums';

import BillingForbiddenFeatureComponent from 'webapp/components/billing/forbidden-feature';
import type { Args } from 'webapp/components/popup/inner/modal';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';

export default class BillingPopupForbiddenFeatureComponent extends PopupInnerModalComponent<PopupData.Billing.ForbiddenFeature> {
	@service('billing') declare billingService: Service.Billing;
	constructor(owner: Owner, args: Args) {
		super(owner, args);

		const eventProperties: {
			feature: BillingFeature;
			trackingOrigin?: string;
		} = {
			feature: this.feature,
		};

		const trackingOrigin = this.trackingOrigin,
			useOriginForTrackingFeature = this.popupData.useOriginForTrackingFeature;
		if (useOriginForTrackingFeature && trackingOrigin) {
			eventProperties.trackingOrigin = trackingOrigin;
		}

		this.billingService.trackLimitationPopupEvent(eventProperties);
	}

	get feature() {
		return this.popupData.feature;
	}

	get sourceType() {
		return this.popupData.sourceType;
	}

	get trackingOrigin() {
		return this.popupData.trackingOrigin;
	}
	<template>
		<div class="content">
			<BillingForbiddenFeatureComponent
				@feature={{this.feature}}
				@sourceType={{this.sourceType}}
				@close={{this.close}}
			/>
		</div>
	</template>
}
